module.exports = __webpack_public_path__ + "static/img/07.69ec5bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/loyaltyvenue/tutorial/07.svg
// module id = cxbE
// module chunks = 13